import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

// 사용자 페이지
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news/detail/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// 관리자 페이지
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminNewsPage = lazy(() => import('../pages/admin/news/page'));
const AdminNewsCreatePage = lazy(() => import('../pages/admin/news/create/page'));
const AdminNewsEditPage = lazy(() => import('../pages/admin/news/create/page')); // 작성 페이지 재활용
const AdminGalleryPage = lazy(() => import('../pages/admin/gallery/page'));
const AdminGalleryCreatePage = lazy(() => import('../pages/admin/gallery/create/page'));
const AdminGalleryEditPage = lazy(() => import('../pages/admin/gallery/create/page')); // 작성 페이지 재활용

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/detail',
    element: <NewsDetailPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  // 관리자 라우트 - 로그인 페이지는 보호하지 않음
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  // 보호된 관리자 라우트
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute>
        <AdminDashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/news',
    element: (
      <ProtectedRoute>
        <AdminNewsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/news/create',
    element: (
      <ProtectedRoute>
        <AdminNewsCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/news/edit/:id',
    element: (
      <ProtectedRoute>
        <AdminNewsEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/gallery',
    element: (
      <ProtectedRoute>
        <AdminGalleryPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/gallery/create',
    element: (
      <ProtectedRoute>
        <AdminGalleryCreatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/gallery/edit/:id',
    element: (
      <ProtectedRoute>
        <AdminGalleryEditPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
